import { Collapse, IconButton, Paper, Typography, makeStyles } from '@material-ui/core'
import { CloseRounded, WarningRounded } from '@material-ui/icons'
import React from 'react'
import { warningBannerStyles } from './warningBanner.styles'

export interface WarningBannerProps {
  show: boolean
  message: string
  onClose?: () => void
}

const useStyles = makeStyles(warningBannerStyles)

export const WarningBanner: React.FC<WarningBannerProps> = ({ show, message, onClose }) => {
  const classes = useStyles()

  return (
    <Collapse in={show} timeout={{ enter: 350, exit: 200 }} unmountOnExit>
      <div className={classes.root}>
        <Paper elevation={0} className={classes.paper}>
          <WarningRounded className={classes.icon} />
          <Typography variant="body2" className={classes.text}>
            {message}
          </Typography>
          {onClose && (
            <IconButton size="small" className={classes.closeButton} onClick={onClose}>
              <CloseRounded fontSize="small" />
            </IconButton>
          )}
        </Paper>
      </div>
    </Collapse>
  )
}
